module.exports = __webpack_public_path__ + "img/type3-2.74b7990e.png";